import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiRegister, ServerResponse, ValidationError } from '../../api';
import ErrorBox from '../../components/errorBox/ErrorBox';
import ErrorMessage from '../../components/errorMessage/ErrorMessage';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './Registration.css';

interface RegistrationState {
    acceptedTerms: string;
    dataPrivacy: string;
    email: string;
    firstName: string;
    lastName: string;
    loading: boolean;
    password: string;
    passwordRepeat: string;
    name: string;
    salutation: string;
    errors: string[];
    serverResponse?: ServerResponse;
}

export default class Registration extends React.PureComponent<any, RegistrationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            acceptedTerms: '',
            dataPrivacy: '',
            email: '',
            errors: [],
            firstName: '',
            lastName: '',
            loading: false,
            name: '',
            password: '',
            passwordRepeat: '',
            salutation: '',
            serverResponse: undefined,
        };
    }

    public render() {
        if (this.state.serverResponse && this.state.serverResponse.OK) {
            return <Redirect to="/registrationActivation" />;
        }

        return (
            <>
                <HeaderLoggedOut />
                <Container id="registrationView">
                    <Row>
                        <Col>
                            <h3>{TR.registration_course_provider_registration}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form>
                                <ErrorBox serverResponse={this.state.serverResponse} />
                                <ErrorMessage errors={this.state.errors} />
                                <FormGroup>
                                    <Label htmlFor="salutation" className={this.errorClass('salutation')}>
                                        {TR.registration_saluation}
                                    </Label>
                                    <Input type="select" name="select" id="salutation" onChange={this.inputHandler}>
                                        <option>{TR.registration_please_choose}</option>
                                        <option value="Frau">Frau</option>
                                        <option value="Herr">Herr</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="firstName" className={this.errorClass('firstName')}>
                                        {TR.registration_firstname}
                                    </Label>
                                    <Input type="text" id="firstName" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="lastName" className={this.errorClass('lastName')}>
                                        {TR.registration_last_name}
                                    </Label>
                                    <Input type="text" id="lastName" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="name" className={this.errorClass('name')}>
                                        {TR.registration_name}
                                    </Label>
                                    <Input type="text" id="name" onChange={this.inputHandler} />
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={6}>
                            <Form>
                                <FormGroup>
                                    <Label htmlFor="email" className={this.errorClass('email')}>
                                        {TR.registration_email}
                                    </Label>
                                    <Input type="text" id="email" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="password" className={this.errorClass('password')}>
                                        {TR.registration_password}
                                    </Label>
                                    <Input type="password" id="password" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor="passwordRepeat" className={this.errorClass('passwordRepeat')}>
                                        {TR.registration_again}
                                    </Label>
                                    <Input type="password" id="passwordRepeat" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Input type="checkbox" id="dataPrivacy" onChange={this.inputHandler} />{' '}
                                    <Label htmlFor="dataPrivacy" className={this.errorClass('dataPrivacy')}>
                                        {TR.registration_i_have}{' '}
                                        <a href="https://kukundo.de/datenschutzerklaerung/" target="_blank">
                                            {TR.registration_data_privacy}
                                        </a>{' '}
                                        {TR.registration_read_and_accepted}
                                    </Label>
                                    <br />
                                    <Input
                                        id="acceptedTerms"
                                        name="AcceptedTerms"
                                        type="checkbox"
                                        onChange={this.inputHandler}
                                    />{' '}
                                    <Label htmlFor="acceptedTerms" className={this.errorClass('acceptedTerms')}>
                                        {TR.registration_i_have}{' '}
                                        <a href="https://kukundo.de/agb-kursanbieter/" target="_blank">
                                            {TR.registration_agb}
                                        </a>{' '}
                                        {TR.registration_read_and_accepted}
                                    </Label>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center mt-4">
                            <Button onClick={this.register}>{TR.registration_register}</Button>
                            <br />
                            <br />
                            <Link to="/">&lt; {TR.registration_back_to_login}</Link>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }

    private inputHandler = (e: any) => {
        this.setState({ serverResponse: undefined });
        const newstate = {};
        if (e.target.id === 'acceptedTerms' || e.target.id === 'dataPrivacy') {
            newstate[e.target.id] = e.target.checked ? 'on' : '';
        } else {
            newstate[e.target.id] = e.target.value;
        }
        this.setState(newstate);
    };

    private errorClass = (fieldname: string) => {
        if (this.state.serverResponse && this.state.serverResponse.Errors) {
            const errorsForThisField = this.state.serverResponse.Errors.filter(
                (error: ValidationError) => error.Parameter.toLowerCase() === fieldname.toLowerCase()
            );
            return errorsForThisField.length > 0 ? 'error' : '';
        }
        return '';
    };

    private register = () => {
        if (this.state.password !== this.state.passwordRepeat) {
            this.setState({ errors: [TR.registration_not_same] });
            return;
        }

        this.setState({ errors: [] }, () => {
            ApiRegister(
                {
                    AcceptedTerms: this.state.acceptedTerms,
                    DataPrivacy: this.state.dataPrivacy,
                    Email: this.state.email,
                    FirstName: this.state.firstName,
                    LastName: this.state.lastName,
                    Name: this.state.name,
                    Password: this.state.password,
                    Salutation: this.state.salutation,
                },
                (sr: ServerResponse) => {
                    this.setState({ serverResponse: sr });
                }
            );
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/registration/Registration.tsx